import axios from 'axios';
import { store } from '../store';
import { LOGOUT } from '../actions/types';

// Create an instance of axios
export const BASE_URL = `${process.env.REACT_APP_BASE_URL}`
const api = axios.create({
    // baseURL: `https://body-sol-backend.tekstagearea.com/api/v1`,
    baseURL: `${BASE_URL}`,
    headers: {
        'Content-Type': 'application/json'
    }
});

/*
NOTE: intercept any error responses from the api
and check if the token is no longer valid.
ie. Token has expired or user is no longer
authenticated.
logout the user if the token has expired
*/

api.interceptors.response.use(
    (res) => res,
    (err) => {
        if (err.response.status === 401) {
            store.dispatch({ type: LOGOUT });
        }
        return Promise.reject(err);
    }
);

export default api;
